<template>
  <div class="right_col" role="main">
    <div>
      <div class="page-title">
        <div class="title_left">
          <h3>
            {{ title }}
            <span v-if="isConfirmView"
              >- {{ $t('orderPage.inputConfirmation') }}</span
            >
          </h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <div class="x_content form-horizontal form-label-left">
              <alert
                :title="title"
                :success-message="$t('common.isSuccess')"
                :error-message="$t('common.isFailure')"
                :alerts="alerts"
                :errors="errors"
                :display="alertDisplay"
                @closeAlert="closeAlert"
              />
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="itemCode"
                >
                  {{ $t('common.itemCode') }}：
                  <span v-if="!isEdit" class="required">*</span>
                </label>
                <div class="col-md-5 col-sm-3 col-xs-12">
                  <input
                    id="itemCode"
                    v-model="itemCode"
                    v-validate="ValidRules.itemCode"
                    :disabled="isConfirmView || isEdit"
                    :data-vv-as="$t('common.itemCode')"
                    :placeholder="$t('common.itemCode')"
                    type="text"
                    name="itemCode"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('itemCode')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'itemCode'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="!isUs" class="form-group">
                <label
                  class="control-label col-md-2 col-sm-4 col-xs-6"
                  style="padding-right: 0"
                  >{{ $t('common.itemName') }}：</label
                >
                <label
                  class="control-label col-md-1 col-sm-4 col-xs-6"
                  style="padding-left: 0"
                  for="nameJa"
                >
                  {{ $t('orderPage.japanese') }}：
                  <span v-if="isJp || isTw || isCn" class="required">*</span>
                </label>
                <div class="col-md-5 col-sm-8 col-xs-6">
                  <input
                    id="nameJa"
                    v-model="names.ja"
                    v-validate="ValidRules.nameJa"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.itemNameJapanese')"
                    :placeholder="$t('common.itemName')"
                    type="text"
                    name="nameJa"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('nameJa')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('nameJa')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  v-if="isUs"
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  >{{ $t('common.itemName') }}：<span class="required"
                    >*</span
                  ></label
                >
                <label
                  v-if="!isUs"
                  class="control-label col-md-3 col-sm-4 col-xs-6"
                  for="nameUs"
                >
                  {{ $t('orderPage.english') }}：
                  <span v-if="isJp || isTw || isUs || isCn" class="required"
                    >*</span
                  >
                </label>
                <div class="col-md-5 col-sm-8 col-xs-6">
                  <input
                    id="nameUs"
                    v-model="names.us"
                    v-validate="ValidRules.nameUs"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.itemNameEnglish')"
                    type="text"
                    name="nameUs"
                    class="form-control"
                    placeholder="Product name"
                  />
                  <div
                    v-show="validator.has('nameUs')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('nameUs')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="!isUs && !isCn" class="form-group">
                <label
                  class="control-label col-md-3 col-sm-4 col-xs-6"
                  for="nameZhTw"
                >
                  {{ $t('orderPage.traditionalChinese') }}：
                  <span v-if="isJp || isTw" class="required">*</span>
                </label>
                <div class="col-md-5 col-sm-8 col-xs-6">
                  <input
                    id="nameZhTw"
                    v-model="names['zh-tw']"
                    v-validate="ValidRules.nameZhTw"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.itemNameTraditionalChinese')"
                    type="text"
                    name="nameZhTw"
                    class="form-control"
                    placeholder="產品名稱"
                  />
                  <div
                    v-show="validator.has('nameZhTw')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'nameZhTw'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="!(isUs || isTw)" class="form-group">
                <label
                  class="control-label col-md-3 col-sm-4 col-xs-6"
                  for="nameZhCn"
                >
                  {{ $t('orderPage.simplifiedChinese') }}：
                  <span v-if="isJp || isCn" class="required">*</span>
                </label>
                <div class="col-md-5 col-sm-8 col-xs-6">
                  <input
                    id="nameZhCn"
                    v-model="names['zh-cn']"
                    v-validate="ValidRules.nameZhCn"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.itemNameSimplifiedChinese')"
                    type="text"
                    name="nameZhCn"
                    class="form-control"
                    placeholder="产品名称"
                  />
                  <div
                    v-show="validator.has('nameZhCn')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'nameZhCn'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="!(isUs || isTw || isCn)" class="form-group">
                <label
                  class="control-label col-md-3 col-sm-4 col-xs-6"
                  for="nameKr"
                >
                  {{ $t('orderPage.korean') }}：
                  <span v-if="isJp" class="required">*</span>
                </label>
                <div class="col-md-5 col-sm-8 col-xs-6">
                  <input
                    id="nameKr"
                    v-model="names['kr']"
                    v-validate="ValidRules.nameKr"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.itemNameKorean')"
                    type="text"
                    name="nameKr"
                    class="form-control"
                    placeholder="상품명"
                  />
                  <div
                    v-show="validator.has('nameKr')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('nameKr')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="calorie"
                >
                  {{ $t('common.calorie') }}：
                </label>
                <div class="col-md-5 col-xs-12">
                  <input
                    id="calorie"
                    v-model="calorie"
                    v-validate="ValidRules.calorie"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.calorie')"
                    :placeholder="$t('common.calorie')"
                    type="text"
                    name="calorie"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('calorie')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('calorie')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="unit"
                >
                  {{ $t('orderPage.unitType') }}：
                  <span class="required">*</span>
                </label>
                <div class="col-md-5 col-xs-12">
                  <select
                    id="unit"
                    v-model="unit"
                    v-validate="ValidRules.unit"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('orderPage.unitType')"
                    name="unit"
                    class="form-control"
                  >
                    <option value>{{ $t('common.unselected') }}</option>
                    <option value="0">{{ $t('orderPage.plate') }}</option>
                    <option value="1">{{ $t('orderPage.piece_hon') }}</option>
                    <option value="2">{{ $t('orderPage.piece_ko') }}</option>
                    <option value="3">{{ $t('orderPage.cup') }}</option>
                  </select>
                  <div
                    v-show="validator.has('unit')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('unit')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="kind"
                >
                  {{ $t('common.manufacturingCategory') }}：
                  <span class="required">*</span>
                </label>
                <div class="col-md-5 col-xs-12">
                  <select
                    id="kind"
                    v-model="itemKindId"
                    v-validate="ValidRules.kind"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('common.manufacturingCategory')"
                    name="kind"
                    class="form-control"
                  >
                    <option value>{{ $t('common.unselected') }}</option>
                    <option
                      v-for="item in itemKinds"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <div
                    v-show="validator.has('kind')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('kind')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="toppings"
                  >{{ $t('orderPage.toppingType') }}：</label
                >
                <div class="col-md-5 col-xs-12">
                  <select
                    id="toppings"
                    v-model="toppings"
                    :disabled="isConfirmView"
                    class="form-control"
                    multiple
                  >
                    <option
                      v-for="topping in allToppings"
                      :key="topping.groupId"
                      :value="topping.groupId"
                    >
                      {{ topping.groupName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="isPriceChange"
                >
                  {{ $t('orderPage.priceChange') }}：
                  <span class="required">*</span>
                </label>
                <div
                  class="form-group col-md-5 col-sm-5 col-xs-12 text-danger select-radio"
                >
                  <div class="col-md-6 col-sm-6 col-xs-6">
                    <input
                      id="isPriceChangeT"
                      v-model="isPriceChange"
                      v-validate="ValidRules.isPriceChange"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('orderPage.priceChange')"
                      type="radio"
                      name="isPriceChange"
                      class="flat"
                      value="1"
                    />
                    <label for="isPriceChangeT" class="control-label">
                      {{ $t('orderPage.applicable') }}
                    </label>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-6">
                    <input
                      id="isPriceChangeF"
                      v-model="isPriceChange"
                      :disabled="isConfirmView"
                      type="radio"
                      class="flat"
                      name="isPriceChange"
                      value="0"
                    />
                    <label for="isPriceChangeF" class="control-label">
                      {{ $t('orderPage.notApplicable') }}
                    </label>
                  </div>
                  <div
                    v-show="validator.has('isPriceChange')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'isPriceChange'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="ln_solid"></div>
              <div class="form-group">
                <div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                  <button @click="back()" class="btn btn-default">
                    {{ $t('common.back') }}
                  </button>
                  <button
                    v-if="!isConfirmView"
                    @click="confirm"
                    class="btn btn-success"
                  >
                    {{ $t('common.inputComplete') }}
                  </button>
                  <button v-else @click="submit" class="btn btn-success">
                    {{ $t('orderPage.registration') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import { mapGetters, mapActions } from 'vuex'
import ItemRequest from '@/http/ItemRequest'
import ValidRules from '@/validator/ItemRules'
import alert from '@/mixin/alert'
export default {
  components: {
    Alert,
  },
  mixins: [alert],
  data() {
    return {
      title: this.$t('orderPage.itemInformationRegistration'),
      itemCode: '',
      itemKindId: '',
      toppings: [],
      unit: '',
      names: {
        ja: '',
        us: '',
        'zh-tw': '',
        'zh-cn': '',
        kr: '',
      },
      calorie: '',
      isPriceChange: 0,
      isEdit: false,
      isConfirmView: false,
      ValidRules: ValidRules,
    }
  },
  computed: {
    ...mapGetters({
      getItemById: 'item/getItemById',
      itemKinds: 'item/getKinds',
      allToppings: 'item/getToppings',
      language: 'settings/getLanguage',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
    isTw() {
      return this.defaultLanguage === 'zh-tw'
    },
    isCn() {
      return this.defaultLanguage === 'zh-cn'
    },
  },
  watch: {
    language() {
      this.fetchKinds()
      this.fetchToppings()
    },
  },
  mounted() {
    if (this.$route.name === 'itemformEdit') {
      this.isEdit = true
      this.title = this.$t('orderPage.editItemInformation')
      this.getStoreData(this.$route.params.id)
    }
    this.fetchKinds()
    this.fetchToppings()
  },
  methods: {
    ...mapActions({
      fetchKinds: 'item/fetchKinds',
      fetchToppings: 'item/fetchToppings',
    }),
    getStoreData: function(id) {
      const item = this.getItemById(id)
      Object.keys(item.toppings).map((key) => {
        this.toppings.push(Number(key))
      })
      this.itemCode = item.itemCode
      this.itemKindId = item.itemKind.id
      this.unit = item.unit
      this.names = item.names
      this.calorie = item.calorie
      this.isPriceChange = item.isPriceChange
    },
    back: function() {
      if (this.isConfirmView) {
        this.isConfirmView = false
      } else {
        this.$router.push({ name: 'item' })
      }
    },
    confirm: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isConfirmView = true
        }
      })
    },
    submit: function() {
      const request = new ItemRequest()
      const params = {
        itemCode: Number(this.itemCode),
        itemKind: Number(this.itemKindId),
        unit: Number(this.unit),
        toppings: this.toppings,
        names: this.removeEmpty(this.names),
        calorie: this.calorie ? Number(this.calorie) : null,
        isPriceChange: Number(this.isPriceChange),
      }

      if (this.isEdit) {
        // 更新
        request
          .update(this.$route.params.id, params)
          .then(() => {
            this.$router.push({
              name: 'item',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      } else {
        // 新規登録
        request
          .insert(params)
          .then(() => {
            this.$router.push({
              name: 'item',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      }
    },
    removeEmpty(obj) {
      return Object.entries(obj)
        .filter(([, v]) => Boolean(v))
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    },
  },
}
</script>
<style scoped>
div.select-radio label {
  margin-left: 3px;
}

div.select-radio div {
  padding-left: 0;
}
</style>
